var React = require('react');

function CheckGreen (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M5.75 12.8665L8.33995 16.4138C9.15171 17.5256 10.8179 17.504 11.6006 16.3715L18.25 6.75","stroke":"#4BB530","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round"}));
}

CheckGreen.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = CheckGreen;

CheckGreen.default = CheckGreen;
